import clsx from 'clsx';
import React__default from 'react';
import { cssWindowBlocker, cssContainerBlocker } from './index.css.js';

/* eslint-disable react/self-closing-comp */
const LoadingIndicator = ({ isLoading = false, className, ...props }) => {
    return isLoading ? React__default.createElement("div", { className: clsx('c-loader', className), ...props }) : null;
};
const WindowBlocker = ({ className, ...props }) => {
    return React__default.createElement("div", { ...props, className: clsx(className, cssWindowBlocker) });
};
const WindowLoadingIndicator = ({ isLoading, ...props }) => {
    return isLoading ? (React__default.createElement(WindowBlocker, { ...props },
        React__default.createElement(LoadingIndicator, { isLoading: isLoading }))) : null;
};
const ContainerBlocker = ({ className, ...props }) => {
    return React__default.createElement("div", { ...props, className: clsx(className, cssContainerBlocker) });
};
const ContainerLoadingIndicator = ({ isLoading, ...props }) => {
    return isLoading ? (React__default.createElement(ContainerBlocker, { ...props },
        React__default.createElement(LoadingIndicator, { isLoading: isLoading }))) : null;
};

export { ContainerBlocker, ContainerLoadingIndicator, LoadingIndicator, WindowBlocker, WindowLoadingIndicator };
//# sourceMappingURL=index.js.map
